<template>
    <zen-one
        :showuserinfo="false"
        title="Cukai Tanah:: Jenis Hakmilik"
        :crumbs="crumbs"
    >
        <z-page :title="`Senarai Jenis Hakmilik`" :append-button="true">
            <w-flex column :gap="3">

                <w-flex class="justify-space-between">
                    <w-button class="align-self-end"  @click="printPdf()">
                        <w-icon class=" mr2 "> fal fa-print</w-icon>&nbsp;Cetak
                    </w-button>
                </w-flex>


            <table
                class="table-dashboard"
                width="100%"

            >
                <thead>
                    <tr>
                        <td >Daerah</td>
                        <td >GRN</td>
                        <td >PN</td>
                        <td >HSD</td>
                        <td >GM</td>
                        <td >PM</td>
                        <td >HSM</td>
                        <td >TIADA MAKLUMAT</td>
                    </tr>
                </thead>

                <tbody v-for="jhm in jhm">
                    <tr >
                        <td align="left">{{ jhm.daerah }}</td>
                        <td>{{ jhm['jenis']['GRN']          }}</td>
                        <td>{{ jhm['jenis']['PN']           }}</td>
                        <td>{{ jhm['jenis']['HSD']          }}</td>
                        <td>{{ jhm['jenis']['GM']           }}</td>
                        <td>{{ jhm['jenis']['PM']           }}</td>
                        <td>{{ jhm['jenis']['HSM']          }}</td>
                        <td>{{ jhm['jenis']['TIADA MAKLUMAT']}}</td>
                    </tr>
                </tbody>
            </table>
            </w-flex>

        </z-page>
    </zen-one>
</template>

<script>
import moment from "moment";
import ZResource from "@/Modules/z-resource";


export default {
    extends: ZResource,
    data() {
        return {
            resourceurl: "cukai-tanah",
            apiBaseUrl: process.env.MIX_API_BASE_URL,
            reload: true,
            loading: false,
            crumbs: [
                { label: this.$page.props.app_name, route: "/sitemap" },
                { label: "Cukai Tanah", route: "/cukai-tanah/dashboard" },
                { label: "Senarai", route: "/cukai-tanah/senarai" },
            ],

            districts: [],
            jhm:[]
        };
    },
    methods: {
        printPdf(){
            window.open( `${this.apiBaseUrl}/cukai/laporanJenisHakmilikPdf`,"_blank");
        },
        async fetchDaerah() {
            await axios({
                method: "get",
                url: `${this.apiBaseUrl}/daerah`,
                responseType: "json",
            }).then((e) => {
                this.districts = e.data
            });
        },
        async dataJHM() {
            await axios({
                method: "get",
                url: `${this.apiBaseUrl}/cukai/laporanJenisHakmilik`,
                responseType: "json",
            }).then((e) => {
                this.jhm = e.data
                console.log(this.jhm);
            });
        },
    },
    computed: {

    },
    mounted() {
        this.dataJHM();
        this.fetchDaerah();
    },
};
</script>
